import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import ContactUsContent from "../ones/ContactUsContent";

export default function View(props) {
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <ContactUsContent />
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
